export default __webpack_public_path__ + "static/media/passed.da8536fe.svg";